//@ts-nocheck
import {
  applySnapshot,
  getSnapshot,
  types,
  Instance,
  flow,
} from "mobx-state-tree";

const State = types.model("State", {
  code: types.optional(types.string, ""),
  name: types.optional(types.string, ""),
});
const Country = types
  .model("Country", {
    states: types.optional(types.array(State), []),
    name: types.optional(types.string, ""),
    code2: types.optional(types.string, ""),
  })
  .views((self) => {
    return {
      get code() {
        return self.code2;
      },
    };
  });
const Region = types.model("Region", {
  state: types.optional(types.string, ""),
  vicinity: types.optional(types.string, ""),
  factor: types.optional(types.number, 1),
});

export type SLocationInfoType = {
  state: string;
  vicinity: string;
  region: string;
  address: string;
  country: string;
  lessonType: string[];
  exemptedAreas: string[];
  supportedCountryAccount?: string;
};
const Bank = types.model("Bank", {
  name: types.optional(types.string, ""),
  code: types.optional(types.string, ""),
});
export const SupportedCountry = types.model("SupportedCountry", {
  name: types.optional(types.string, ""),
  currencySymbol: types.optional(types.string, ""),
  currencyName: types.optional(types.string, ""),
  dialCode: types.optional(types.string, ""),
  countryCode: types.optional(types.string, ""),
  banks: types.optional(types.array(Bank), []),
});
export const LocationFieldStore = types
  .model("LocationField", {
    // lessonType: types.optional(types.array(types.string), ["physical"]),
    lessonType: types.union(
      types.optional(types.array(types.string), ["physical"]),
      types.optional(
        types.enumeration("lessonType", ["physical", "online"]),
        "physical",
      ),
    ),
    country: types.optional(types.string, ""),
    country_code: types.optional(types.string, ""),
    latitude: types.optional(types.number, 0),
    longitude: types.optional(types.number, 0),
    state: types.optional(types.string, ""),
    region: types.optional(types.string, ""),
    vicinity: types.optional(types.string, ""),
    address: types.optional(types.string, ""),
    countries: types.optional(types.array(Country), []),
    regions: types.optional(types.array(Region), []),
    countriesSupported: types.optional(types.array(SupportedCountry), []),
    // supportedCountries: types.optional(types.array(types.string), ["Nigeria"]),
    exemptedAreas: types.optional(types.array(types.string), []),
    supportedCountryAccount: types.optional(types.string, ""),
    neighboringRegion: types.optional(types.string, ""),
    customerType: types.optional(types.string, "parent"),
    phone: types.optional(types.string, ""),
  })
  .extend((self) => {
    let getStates = (country) => {
      if (country) {
        let stateOptions = self.countries.find((item) => item.name === country);
        if (stateOptions) {
          stateOptions = stateOptions.states.map((item) => item.name);
        }
        return stateOptions || [];
      }
      return [];
    };
    let getRegions = (state) => {
      if (state) {
        let regionOptions = self.regions
          .filter((item) => item.state === state)
          .map((item) => item.vicinity);
        return regionOptions;
      }
      return [];
    };
    const getNeighboringArea = flow(function* getNeighboringArea() {
      const { adapter } = getEnv(self);
      try {
        const response = yield adapter.getNeighboringArea(self.region);
        const neighboringArea = response.find((res) => res.distance > 12);
        if (Array.isArray(neighboringArea)) {
          self.neighboringRegion =
            neighboringArea[neighboringArea.length - 1]?.region;
        } else {
          self.neighboringRegion = neighboringArea?.region;
        }
      } catch (error) {
        console.log(error);
      }
    });

    const handleChange = (key, selectedOption) => {
      if (key === "lessonType") {
        self.lessonType = selectedOption;
      }
      if (key === "state") {
        self.state = selectedOption;
        self.region = "";
        self.region = "";
        self.vicinity = "";
        self.address = "";
      }

      if (key === "region") {
        if (selectedOption) {
          self.region = selectedOption;
          self.vicinity = "";
          self.address = "";
          // getNeighboringArea();
        } else {
          self.region = "";
        }
      }
      if (key === "country") {
        self.country = selectedOption;
        self.state = "";
        self.region = "";
        self.vicinity = "";
        self.address = "";
        if (!self.supportedCountries.includes(self.country)) {
          self.lessonType = ["online"];
        }
      }
      return {
        country: self.country,
        state: self.state,
        region: self.region,
        address: self.address,
        vicinity: self.vicinity,
        lessonType: self.lessonType,
      };
    };
    return {
      views: {
        get clientLessonType() {
          return Array.isArray(self.lessonType)
            ? self.lessonType[0]
            : self.lessonType;
        },
        get supportedCountries() {
          return self.countriesSupported.map((o) => o.name);
        },
        get countryCode() {
          return self.country_code;
        },
        inSupportedCountry(country: string) {
          return self.supportedCountries.includes(country);
        },
        get landingProps() {
          return {
            customerType: self.customerType,
            country: self.country,
            phone: self.phone,
            country_code: self.country_code,
          };
        },
        stateOptions(country): any {
          return getStates(country);
        },
        regionOptions(state) {
          return getRegions(state);
        },
        get countryOptions() {
          return self.countries.map((item) => item.name);
        },
        getCountryCode(country) {
          let countryObj = self.countries.find((item) => item.name === country);
          return countryObj?.code2;
        },
        get factor() {
          let filteredRegion = self.regions.find(
            (item) =>
              item.state === self.state && item.vicinity === self.region,
          );

          let factor = filteredRegion?.factor ? filteredRegion.factor : 1;
          return factor;
        },
        get lessonTypeOptions() {
          return ["physical", "online"];
        },
        get completed() {
          if (self.lessonType.includes("physical")) {
            return Boolean(
              self.country &&
                self.state &&
                self.region &&
                self.address &&
                self.vicinity &&
                self.exemptedAreas.length > 2,
            );
          } else {
            return Boolean(self.country && self.state);
          }
        },

        get placeholder() {
          let placeholders = {
            lessonType: {
              label: "Lesson type",
              options: [
                {
                  label: "Physical",
                  description: "Home lessons",
                  value: "physical",
                },
                {
                  label: "Online",
                  description: "Virtual lessons",
                  value: "online",
                },
              ],
            },
            country: {
              label: "Country",
              placeholder: "Select country",
            },
            state: {
              label: "State",
              placeholder: "Select state",
            },
            region: {
              label: "Region",
              placeholder: "Select region",
            },
          };

          return {
            country: placeholders.country,
            state: placeholders.state,
            region: placeholders.region,
          };
        },
        formatOptions(options = []) {
          if (Array.isArray(options)) {
            return options.map((item) => ({ label: item, value: item }));
          }
          return [];
        },

        get formValues(): SLocationInfoType {
          return {
            latitude: self.latitude,
            longitude: self.longitude,
            state: self.state,
            vicinity: self.vicinity,
            region: self.region,
            address: self.address,
            country: self.country,
            supportedCountryAccount: self.supportedCountryAccount,
            lessonType: getSnapshot(self.lessonType),
            exemptedAreas: getSnapshot(self.exemptedAreas),
          };
        },
        get asJSON() {
          return { ...getSnapshot(self), lessonType: self.clientLessonType };
        },
      },
      actions: {
        afterCreate() {
          // getNeighboringArea()
          if (self.regions.length === 0) {
            // initializeRegions();
          }
        },
        handleChange,
        getNeighboringArea,
        updateFields(values) {
          console.log(values);
          const oldValues = getSnapshot(self);
          applySnapshot(self, { ...oldValues, ...values });
        },
        setlessonType(type) {
          self.lessonType = type;
        },
      },
    };
  });

export default LocationFieldStore;
export interface ILocationFieldStore
  extends Instance<typeof LocationFieldStore> {}
